import { 
  calculatePliseUsedM2,
  createDefaultPliseItem,
  DEFAULT_PLISE_MONTAJ_OPTION,
  getPliseMontajExtraPrice,
  normalizePliseMontajSettings,
  parsePliseExtrasFromSettings, 
  calculateDiscountedPrice, 
  calculateUsedM2, 
  calculatePileDensity,
  calculateCapsulePrice,
  calculateTotalPrice,
  calculateAstarPrice,
  calculateOzelTasarimTotal,
  calculateJaluziUsedM2,
  calculateJaluziTotalPrice,
  calculateDikeyPerdeTotalPrice,
  calculateAksesuarTotalPrice,
  calculateKatlamaliPerdeUsedM,
  calculateKatlamaliPerdeDikimPrice,
  calculateKatlamaliPerdeTotalPrice,
  parseKatlamaliExtrasFromSettings,
  calculateTotalCost,
  calculateStorZebraUsedM2,
  calculateStorZebraTotalPrice,
  getStorZebraCalcOptions,
  resolveStorWidthLimitCm,
  calculateRustikTotalPrice,
  calculateRaySistemiUsedMeter,
  calculateRustikUsedCm,
  DEFAULT_RUSTIK_MIN_CM,
  DEFAULT_RUSTIK_OLCU_TAMAMLAMA,
} from '../../../utils';

export { 
  calculatePliseUsedM2,
  createDefaultPliseItem,
  DEFAULT_PLISE_MONTAJ_OPTION,
  getPliseMontajExtraPrice,
  normalizePliseMontajSettings,
  parsePliseExtrasFromSettings, 
  calculateDiscountedPrice, 
  calculateUsedM2, 
  calculatePileDensity,
  calculateCapsulePrice,
  calculateTotalPrice,
  calculateAstarPrice,
  calculateOzelTasarimTotal,
  calculateJaluziUsedM2,
  calculateJaluziTotalPrice,
  calculateDikeyPerdeTotalPrice,
  calculateAksesuarTotalPrice,
  calculateKatlamaliPerdeUsedM,
  calculateKatlamaliPerdeDikimPrice,
  calculateKatlamaliPerdeTotalPrice,
  parseKatlamaliExtrasFromSettings,
  calculateTotalCost,
  calculateStorZebraUsedM2,
  calculateStorZebraTotalPrice,
  getStorZebraCalcOptions,
  resolveStorWidthLimitCm,
  calculateRustikTotalPrice,
  calculateRaySistemiUsedMeter,
  calculateRustikUsedCm,
  DEFAULT_RUSTIK_MIN_CM,
  DEFAULT_RUSTIK_OLCU_TAMAMLAMA,
};

/**
 * Plise Batch Hesaplama Yardımcı Fonksiyonu
 */
export const calculatePliseBatchTotals = (items, p1Price, p2Price, mounting, discount, globalQty = 1, montajSettings = {}) => {
  const montajPrices = normalizePliseMontajSettings(montajSettings);
  const gQty = parseFloat(globalQty) || 1;

  if (!Array.isArray(items) || items.length === 0) {
    const mount = (parseFloat(mounting) || 0) * gQty;
    return {
      items: items || [],
      totalPrice: mount > 0 ? mount.toFixed(2) : '0.00',
      discountedPrice: null
    };
  }

  const p1 = parseFloat(p1Price) || 0;
  const p2 = parseFloat(p2Price) || 0;
  const mount = parseFloat(mounting) || 0;
  const disc = parseFloat(discount) || 0;

  let totalRowsSum = 0;
  const updatedItems = items.map(item => {
    const m2 = calculatePliseUsedM2(item.width, item.height);
    const qty = parseFloat(item.quantity) || 1;
    const montajOption = item.montajOption || DEFAULT_PLISE_MONTAJ_OPTION;
    const montajExtra = getPliseMontajExtraPrice(montajPrices, montajOption);
    const unitPrice = p1 + (item.multisistem ? p2 : 0) + montajExtra;
    const rowTotal = m2 * unitPrice * qty;
    totalRowsSum += rowTotal;
    return {
      ...item,
      montajOption,
      usedM2: m2.toFixed(2),
      rowTotal: rowTotal.toFixed(2)
    };
  });

  const finalTotal = (totalRowsSum + mount) * gQty;
  const totalPrice = finalTotal.toFixed(2);
  let discountedPrice = null;

  if (disc > 0) {
    discountedPrice = calculateDiscountedPrice(finalTotal, disc).toFixed(2);
  }

  return {
    items: updatedItems,
    totalPrice,
    discountedPrice
  };
};

/**
 * Kanat siparişinde özel tasarım / astar bayraklarını kayıtlı veriye göre senkronlar.
 * Düzenleme ve kopyalama sırasında accordion ile firma seçimlerinin otomatik açılması için kullanılır.
 */
export const normalizeOrderForForm = (order) => {
  if (!order) return order;

  const normalized = {
    ...order,
    altEtekKatlama: !!order.altEtekKatlama,
    accessories: Array.isArray(order.accessories) ? order.accessories : []
  };

  if (order.productType === 'kanat') {
    normalized.hasOzelTasarim = !!(order.hasOzelTasarim || order.ozelProductName);
    normalized.hasAstar = !!(order.hasAstar || order.astarProductName);
  }

  if (order.productType === 'plise' && Array.isArray(normalized.pliseItems)) {
    normalized.pliseItems = normalized.pliseItems.map((item) => ({
      ...item,
      montajOption: item.montajOption || DEFAULT_PLISE_MONTAJ_OPTION
    }));
  }

  if (order.productType === 'rustik') {
    normalized.rustikMinCm = order.rustikMinCm || DEFAULT_RUSTIK_MIN_CM;
    normalized.rustikOlcuTamamlama = order.rustikOlcuTamamlama || DEFAULT_RUSTIK_OLCU_TAMAMLAMA;
    if (normalized.width) {
      normalized.usedM2 = calculateRustikUsedCm(normalized.width, {
        rustikMinCm: normalized.rustikMinCm,
        rustikOlcuTamamlama: normalized.rustikOlcuTamamlama
      });
    }
  }

  return normalized;
};

/**
 * Boş sipariş state'i döndürür
 */
export const getInitialOrderState = () => ({
  roomName: '',
  productName: '',
  productVariant: '',
  width: '',
  height: '',
  pileModel: '',
  pileDensity: '',
  usedM2: '',
  usedM: '',
  usedMeter: '',
  olcuTamamlama: '',
  unitPrice: '',
  extraPrice: '',
  capsuleUnitPrice: '',
  capsulePrice: '',
  altEtekKatlama: false,
  hasOzelTasarim: false,
  ozelProductName: '',
  ozelProductVariant: '',
  ozelWidth: '',
  ozelHeight: '',
  ozelUnitPrice: '',
  ozelPileModel: '',
  ozelPileDensity: '',
  ozelUsedM2: '',
  ozelExtraPrice: '',
  ozelQuantity: '',
  ozelBaseUnitPrice: '',
  ozelCapsuleUnitPrice: '',
  ozelCapsulePrice: '',
  ozelTotalPrice: '',
  hasAstar: false,
  astarProductName: '',
  astarProductVariant: '',
  astarUnitPrice: '',
  astarPrice: '',
  jumboSystem: '',
  reductor: '',
  bottomSkirt: '',
  closedCase: '',
  laser: '',
  mounting: '',
  motorType: '',
  motorPrice: '',
  motorPriceCurrency: '',
  isJumbo: false,
  hasAltEtekDilim: false,
  isKapaliKasa: false,
  direction: '',
  pliseItems: [],
  pliseProduct1Name: '',
  pliseProduct1Price: '',
  pliseProduct2Name: '',
  pliseProduct2Price: '',
  pliseProduct1Variation: '',
  pliseProduct2Variation: '',
  pliseCaseVariation: '',
  unitCost: '',
  totalCost: '0.00',
  discount: '',
  birimTipi: 'adet',
  quantity: '',
  totalPrice: '',
  discountedPrice: '',
  notes: '',
  accessories: [],
  rayOptions: [],
  rustikMinCm: DEFAULT_RUSTIK_MIN_CM,
  rustikOlcuTamamlama: DEFAULT_RUSTIK_OLCU_TAMAMLAMA
});

/**
 * Firebase için veri temizleme (undefined ve gereksiz alanları kaldırır)
 */
export const cleanOrderData = (orderData) => {
  return Object.entries(orderData).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

/**
 * Genel sipariş özetini hesaplar (Ara toplam, iskonto, vade, bakiye vb.)
 */
export const calculateOrderSummary = (orders, genelIskontoYuzde, vadeliYuzde, paidAmount) => {
  // Ara toplam (Ürünlerin toplamı)
  const totalAmount = orders.reduce((sum, order) => sum + (parseFloat(order.totalPrice) || 0), 0);

  // Ürünlerin indirimli toplamı
  const discountedTotalAmount = orders.reduce((sum, order) => {
    if (order.discountedPrice && parseFloat(order.discount) > 0) {
      return sum + parseFloat(order.discountedPrice);
    }
    return sum + (parseFloat(order.totalPrice) || 0);
  }, 0);

  // Genel İskontolu Toplam
  const iskontoluToplam = genelIskontoYuzde && parseFloat(genelIskontoYuzde) > 0 
    ? calculateDiscountedPrice(discountedTotalAmount, genelIskontoYuzde) 
    : discountedTotalAmount;

  // Vadeli Toplam
  const vadeliToplam = vadeliYuzde && parseFloat(vadeliYuzde) > 0 
    ? calculateDiscountedPrice(iskontoluToplam, -parseFloat(vadeliYuzde)) 
    : iskontoluToplam;

  // Net Ödenecek Tutar (Genel Toplam)
  const toplamOdeme = vadeliToplam;

  // Kalan Ödeme
  const remainingAmount = Math.max(0, toplamOdeme - (parseFloat(paidAmount) || 0));

  return {
    totalAmount,
    discountedTotalAmount,
    iskontoluToplam,
    vadeliToplam,
    toplamOdeme,
    remainingAmount
  };
};

/**
 * Boş sipariş objesi döndürür (handleAddOrder sonrası temizlik için)
 */
export const getEmptyOrder = () => ({
  roomName: '',
  productName: '',
  productVariant: '',
  width: '',
  height: '',
  pileModel: '',
  pileDensity: '',
  usedM2: '',
  usedM: '',
  usedMeter: '',
  olcuTamamlama: '',
  unitPrice: '',
  extraPrice: '',
  capsuleUnitPrice: '',
  capsulePrice: '',
  jumboSystem: '',
  reductor: '',
  bottomSkirt: '',
  closedCase: '',
  laser: '',
  mounting: '',
  hasOzelTasarim: false,
  ozelProductName: '',
  ozelProductVariant: '',
  ozelWidth: '',
  ozelHeight: '',
  ozelUnitPrice: '',
  ozelPileModel: '',
  ozelPileDensity: '',
  ozelUsedM2: '',
  ozelExtraPrice: '',
  ozelQuantity: '',
  ozelBaseUnitPrice: '',
  ozelCapsuleUnitPrice: '',
  ozelCapsulePrice: '',
  ozelTotalPrice: '',
  hasAstar: false,
  astarProductName: '',
  astarProductVariant: '',
  astarUnitPrice: '',
  astarPrice: '',
  pliseItems: [],
  pliseProduct1Name: '',
  pliseProduct1Price: '',
  pliseProduct2Name: '',
  pliseProduct2Price: '',
  pliseProduct1Variation: '',
  pliseProduct2Variation: '',
  pliseCaseVariation: '',
  backgroundCurtain: '',
  blackout: '',
  crepTul: '',
  multisistem: '',
  honeycomb: '',
  standartPlise: '',
  fabricPrice: '',
  mechanismType: '',
  mechanismPrice: '',
  dikimPrice: '',
  accessoryPrice: '',
  quantity: '',
  discount: '',
  totalPrice: '',
  discountedPrice: '',
  notes: '',
  direction: '',
  hasZebraJumbo: false,
  hasZebraAltEtekDilim: false,
  hasZebraKapaliKasa: false,
  zebraJumboAmount: 0,
  zebraAltEtekDilimAmount: 0,
  zebraKapaliKasaAmount: 0,
  accessories: [],
  rayOptions: [],
  rustikMinCm: DEFAULT_RUSTIK_MIN_CM,
  rustikOlcuTamamlama: DEFAULT_RUSTIK_OLCU_TAMAMLAMA
});
